import {
    ExternalLinkInIframeHandlerBase,
    ExternalLinkInIframeRendererParams
} from "../external-link-in-iframe-handler-base";
import {IPendingPlayExternalLinkHandler} from "./pending-play.external-link-handler.interface";
import {GNWP_SOURCES} from "../../../../../sdk/src/components/external_links/external_links_consts";
import {ExternalLinksZIndexes} from "../../external-links-z-indexes";
import {IOpenPendingPlayOptions} from "../../external-links.service.interface";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";


export class PendingPlayExternalLinkHandler extends ExternalLinkInIframeHandlerBase implements IPendingPlayExternalLinkHandler {
    async openPendingPlay(options: IOpenPendingPlayOptions): Promise<void> {
        const url = await this._getGnwpUrl(options);
        await this._showExternalLinkDialog(url);
    }

    protected async _getGnwpUrl(options: IOpenPendingPlayOptions): Promise<string> {
        return await this.services.gnwp.getPendingPlayUrl({
            token: options.token
        });
    }
    protected _getGnwpSource(): GNWP_SOURCES {
        return GNWP_SOURCES.PENDING_PLAY;
    }

    protected _getIframeRendererParams(): ExternalLinkInIframeRendererParams {
        return {
            maxWidth: 1014,
            maxHeight: 702,
            zIndex: ExternalLinksZIndexes.MyAccount,
            httpVerb: 'POST',
            analyticsAction: this._getGnwpSource(),
            hideCloseButton: this._hideCloseButton
        };
    }

    protected get _hideCloseButton(): boolean {
        return false;
    }

    protected async _onPostMessageReceived(message: MessageEvent): Promise<void> {
        const actionId = this._extractActionId(message);

        if(!actionId) {
            return;
        }

        switch (actionId.toLowerCase()) {
            case 'pending':
                this._closeExternalLinkDialog();
                break;
            case '7':
                await this._openQuickDeposit({
                    promCode: this._extractPromoCode(message),
                    channel: {
                        source: CHANNEL_SOURCE.pendingPlay,
                        area: AreaType.PendingAction,
                        element: CHANNEL_ELEMENTS.depositButton
                    }
                });
                break;
        }
    }



}